var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.search.js
// module id = 431
// module chunks = 0